import React from 'react';
import { motion } from 'framer-motion';
import { Award, CheckIcon } from 'lucide-react';
const trustBullets = ['Más de 4.600 compradores satisfechos', 'Recetas testeadas y probadas', 'Descarga inmediata y acceso de por vida', 'Compatible con cualquier dispositivo'];
export function GuaranteeSection() {
  return <section className="w-full py-12 px-6 bg-background" data-id="element-297">
      <div className="max-w-[700px] mx-auto" data-id="element-298">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5
      }} className="border-2 border-dashed border-primary/30 bg-surface/50 rounded-2xl p-8 md:p-10 text-center flex flex-col items-center" data-id="element-299">
          <div className="w-16 h-16 bg-[#FAECE7] text-primary rounded-full flex items-center justify-center mb-6" data-id="element-300">
            <Award className="w-8 h-8" strokeWidth={2} data-id="element-301" />
          </div>

          <h2 className="text-2xl md:text-3xl font-serif mb-4 text-charcoal" data-id="element-302">
            Lo que garantizamos
          </h2>

          <p className="text-lg text-charcoal/70 max-w-md mx-auto leading-relaxed mb-8" data-id="element-303">
            Este recetario tiene más de 4.600 descargas verificadas y una
            calidad que podés ver antes de comprar. No prometemos devoluciones
            porque no las necesitamos — el producto habla solo.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 w-full max-w-lg" data-id="element-304">
            {trustBullets.map((bullet, index) => <div key={index} className="flex items-center gap-2 bg-white/80 border border-[#1D9E75]/15 rounded-lg px-3 py-2.5" data-id="element-305">
                <CheckIcon className="w-4 h-4 text-[#1D9E75] flex-shrink-0" data-id="element-306" />
                <span className="text-sm text-charcoal/80 text-left" data-id="element-307">
                  {bullet}
                </span>
              </div>)}
          </div>

          <motion.button whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} onClick={() => {
          window.location.href = 'https://valordigital.store/cart/46518849142973:1';
        }} className="mt-10 w-full md:w-auto bg-primary hover:bg-primary-hover text-white font-bold uppercase tracking-wider py-4 px-8 rounded-xl shadow-soft transition-colors text-base" data-id="element-308">
            Descargar ahora — 50% OFF →
          </motion.button>
        </motion.div>
      </div>
    </section>;
}